export const ADMIN_MESSAGE_MAX_RECIPIENTS = 50;
export const ADMIN_MESSAGE_TITLE_MAX_LENGTH = 120;
export const ADMIN_MESSAGE_BODY_MAX_LENGTH = 2000;
